export default "__VITE_ASSET__4945d121__"